import React from 'react';

//Styles
import './Home.scss';

//Font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";

//Components
import Carousel from '../Components/Carousel';
import PortfolioSlider from '../Components/PortfolioSlider';

//Certificate paths
import ISO9001 from '../Img/Certificates/iso9001.jpg';
import ISO14001 from '../Img/Certificates/iso14001.jpg';
import ISO18001 from '../Img/Certificates/iso18001.jpg';

//SVG icons
import Dots from '../Icons/Dots';
import Square from '../Icons/Square';
import Circle from '../Icons/Circle';   
import { NavLink } from 'react-router-dom';

function Home(props) {
    return (
        <div className="homeView">
            <Carousel />

            <div className="container">
                {/* <div className="rentalOffer">
                    <p>Rental of top technology at great prices</p>
                    <NavLink to="/rental" onClick={()=>props.scrollToTop()}>To rent</NavLink>
                </div> */}

                <div className="aboutUs section">
                    <h2>About Us <Dots /></h2>

                    <div className="container-inner">
                        <h4>GOLD CONSTRUCTION LIMITED</h4>
                        <div className="text">
                            <p>We GOLD CONSTRUCTION LIMITED, one of the growing construction company in Zambia. We have a broad portfolio of successfully completed projects across a range of sectors including Industrial, Commercial, Residential, Restoration, Refurbishment and Hospitality</p>

                            <p>We are known for our client focus and hands-on approach. We are proud of the fact that the majority of our workload comes from our existing clients and that we have a strong reputation for our competitive edge and reliable execution of all projects undertaken. This is achieved through our relentless attention to detail and an experienced team with the drive and customer focus to ensure client delight.</p>

                            <div className="showMore">
                                <NavLink to="/about" onClick={() => props.scrollToTop()}>Show more <span><FontAwesomeIcon icon={faLongArrowAltRight} /></span></NavLink>
                            </div>
                        </div>
                    </div>

                    <Square />
                </div>

                <div className="portfolio section">
                    <h2>Portfolio <Dots /></h2>

                    <div className="container-inner">
                        <h4>Our latest works</h4>

                        <Square />
                        <PortfolioSlider />
                    </div>
                </div>

                {/* <div className="certificates section">
                    <h2>Certificates <Dots /></h2>

                    <div className="container-inner">
                        <div className="card-container">
                            <div className="card">
                                <h4>ISO 9001</h4>
                                <p>Quality certificate</p>
                                <img src={ISO9001} alt="ISO9001 Certificate" />

                                <div className="box">
                                    <NavLink to="">Find out more</NavLink>

                                    <div className="showMore">
                                        <NavLink to="">View certificate <span><FontAwesomeIcon icon={faLongArrowAltRight} /></span></NavLink>
                                    </div>
                                </div>

                            </div>

                            <div className="card">
                                <h4>ISO 14001</h4>
                                <p>Environmental certificate</p>
                                <img src={ISO14001} alt="ISO14001 Certificate" />

                                <div className="box">
                                    <NavLink to="">Find out more</NavLink>

                                    <div className="showMore">
                                        <NavLink to="">View certificate <span><FontAwesomeIcon icon={faLongArrowAltRight} /></span></NavLink>
                                    </div>
                                </div>
                            </div>

                            <div className="card">
                                <h4>OHSAS 18001</h4>
                                <p>Safety certificate</p>
                                <img src={ISO18001} alt="ISO18001 Certificate" />

                                <div className="box">
                                    <NavLink to="">Find out more</NavLink>

                                    <div className="showMore">
                                        <NavLink to="">View certificate <span><FontAwesomeIcon icon={faLongArrowAltRight} /></span></NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}


            </div>

            <div className="allWorks">
                <Circle />

                <div className="container">
                    <h3>Want to see all our work? </h3>
                    <NavLink to="/portfolio" onClick={() => props.scrollToTop()}>View the entire portfolio</NavLink>
                </div>
            </div>

            <div className="contact section">
                <div className="container">
                    <h2>Contact <Dots /></h2>

                    <div className="container-inner">
                        <div className="wrapper">
                            <div className="info">
                                <div className="column">
                                    <div className="heading">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                                        <h4>Where are we</h4>
                                    </div>
                                    <p>Plot No. 123/B, Washama Road,</p>
                                    <p>Villa Elizabeth,</p>
                                    <p>Lusaka, Zambia</p>
                                </div>

                                <div className="column">
                                    <div className="heading">
                                        <FontAwesomeIcon icon={faPhoneAlt} />
                                        <h4>Contact</h4>
                                    </div>
                                    <p>+260971564418</p>
                                    <p>+260975112233</p>
                                    <p>ravlot007@gmail.com</p>
                                </div>

                                {/* <div className="column">
                                    <div className="heading">
                                        <FontAwesomeIcon icon={faClock} />
                                        <h4>Working time</h4>
                                    </div>
                                    <p>Monday - Friday</p>
                                    <p>8:00 - 18:00</p>
                                </div> */}
                            </div>



                            {/* <div className="form">
                                <form>
                                    <input type="text" placeholder="Name" />
                                    <input type="email" placeholder="Email" />

                                    <textarea placeholder="Message"></textarea>

                                    <div className="send">
                                        <FontAwesomeIcon icon={faPaperPlane} />
                                        <NavLink to="">To Send</NavLink>
                                    </div>
                                </form>
                            </div> */}
                        </div>
                    </div>
                </div>

                <Square />
            </div>
        </div>
    )
}

export default Home;